import React from "react"
import { NavLink } from "react-router-dom"
import OwlCarousel from "react-owl-carousel"
import "owl.carousel/dist/assets/owl.carousel.css"
import "owl.carousel/dist/assets/owl.theme.default.css"

const filters = [
  { label: "Residential", filter: ".col-one" },
  { label: "Commercial", filter: ".col-two" },
  { label: "Mixed-used Development", filter: ".col-three" },
]

const projects = [
  {
    image: require("./../../images/grand/1.png"),
    title: "The Grand Hayah Hotel",
    href: "Grand",
    address: "Redsea, Saudi Arabia",
    filter: "col-two",
  },
  {
    image: require("./../../images/lotus/5.png"),
    title: "Modern",
    href: "Lotus",
    address: "New cairo- Egypt",
    filter: "col-one",
  },
  {
    image: require("./../../images/four/1.png"),
    title: "Four season Jeddah hotel",
    href: "four",
    address: "Jeddah, Saudi Arabia",
    filter: "col-three",
  },
  {
    image: require("./../../images/Marseilia/26.png"),
    title: "Marseilia Villa",
    href: "Marseilia",
    address: "North Coast",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/27.png"),
    title: "Banafseg Duplex",
    href: "Banafseg",
    address: "Banafseg, New Cairo",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/28.png"),
    title: "Icity Apartment",
    href: "Icity",
    address: "Mountain view, New Cairo",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/29.png"),
    title: "Ivilla",
    href: "Ivilla",
    address: "Mountain view, New Cairo",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/30.png"),
    title: "Villa Marassi",
    href: "Marassi",
    address: "Marassi, North Coast",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/31.png"),
    title: "Apartment Palm Hills",
    href: "Palm",
    address: "Palm Hills, Cairo",
    filter: "col-one",
  },
  {
    image: require("./../../images/Marseilia/32.png"),
    title: "Villa Contemporary Luxury KSA",
    href: "Jeddah1",
    address: "Jeddah, KSA",
    filter: "col-one",
  },
   {
    image: require("./../../images/Marseilia/33.png"),
    title: "Villa Modern Luxury KSA",
    href: "Jeddah2",
    address: "Jeddah, KSA",
    filter: "col-one",
  },
]

var bgimg1 = require("./../../images/background/cross-line2.png")

class Projects1 extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script")
        script.src = src
        script.addEventListener("load", function () {
          resolve()
        })
        script.addEventListener("error", function (e) {
          reject(e)
        })
        document.body.appendChild(script)
        document.body.removeChild(script)
      })
    }

    loadScript("./assets/js/custom.js")
  }
  render() {
    const options = {
      loop: false,
      autoplay: false,
      margin: 30,
      nav: true,
      dots: false,
      navText: ["Prev", "Next"],
      responsive: {
        0: {
          items: 1,
        },
        540: {
          items: 2,
        },
        768: {
          items: 3,
        },
        991: {
          items: 3,
        },
        1136: {
          items: 4,
        },
        1366: {
          items: 5,
        },
      },
    }
    return (
      <>
        <div className="section-full mobile-page-padding  p-t80 p-b50 bg-white">
          <div className="section-content">
            <div className="container">
              {/* TITLE START */}
              <div className="section-head">
                <div className="sx-separator-outer separator-center">
                  <div
                    className="sx-separator bg-white bg-moving bg-repeat-x"
                    style={{
                      backgroundImage: "url(" + bgimg1 + ")",
                      width: "100%",
                    }}
                  >
                    <h3 className="sep-line-one">ALL PROJECTS</h3>
                  </div>
                </div>
              </div>
              {/* TITLE END */}
            </div>
            <div className=" filter-carousal-1-outer relative z-index1">
              <div className="container">
                {/* TITLE START */}
                <div className="text-center clearfix filter-pos-right shadow m-b30">
                  <ul className="btn-filter-wrap">
                    <li className="btn-filter btn-active" data-filter="*">
                      All
                    </li>
                    {filters.map((item, index) => (
                      <li
                        key={index}
                        className="btn-filter"
                        data-filter={item.filter}
                      >
                        {item.label}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              {/* TITLE END */}
              <div className="filter-carousal-1  container-fluid p-b30">
                {/* IMAGE CAROUSEL START */}
                <div className="section-content ">
                  <OwlCarousel
                    className="owl-carousel owl-carousel-filter  owl-btn-bottom-center mfp-gallery navigation-with-name"
                    {...options}
                    style={{ justifyContent: "center", display: "flex" }}
                  >
                    {projects.map((item, index) => (
                      <div
                        key={index}
                        className={`${item.filter} item fadingcol overflow-hide`}
                      >
                        <a href={`/${item.href}`} style={{ cursor: "pointer" }}>
                          <div className="sx-box   image-hover-block">
                            <div className="sx-thum-bx">
                              <img src={item.image} alt="" />
                            </div>
                            <div className="sx-info  p-t20 text-white">
                              <h4 className="sx-tilte">
                                <NavLink to={`/${item.href}`}>
                                  {item.title}
                                </NavLink>
                              </h4>
                              <p className="m-b0">{item.address}</p>
                            </div>
                            <a className="mfp-link" href={item.image}>
                              <i className="fa fa-arrows-alt" />
                            </a>
                          </div>
                        </a>
                      </div>
                    ))}
                  </OwlCarousel>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Projects1
